<script>
import compoment from '@/components/draggable/SmartComponents/basicComponents/SdataTime/SdataTimePreview'
export default {
  name: 'SBirthdayPreview',
  extends: compoment
}
</script>
<style lang="scss">

</style>
